import { GetFamilyAPICall } from 'reactApp/api/family/GetFamilyAPICall';
import { GetFamilyFolderListCall } from 'reactApp/api/family/GetFamilyFolderListCall';
import { getFavoritesListAPICall } from 'reactApp/api/FavoritesListAPICall';
import { familyFoldersSharingInFavorites } from 'reactApp/appHelpers/featuresHelpers/features/familyFoldersSharingInFavorites';
import { getLoadMoreLimit } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store } from 'reactApp/store';
import type { Action, AnyAction } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';

import api from '../../../public/js/Cloud/Application/api';
import { ESortOder } from '../sort/sort.types';
import { EFavoritesFetch, EFavoritesFetchCount } from './favorites.constants';

const FAVORITES_LOAD_LIMIT = getLoadMoreLimit(EStorageType.favorites);

const callApiLoad = (data: any): any => getFavoritesListAPICall().makeRequest(data);

const request = (): Action => ({
    type: EFavoritesFetch.REQUEST,
});

export const favoritesFetchSuccess = (payload: any): AnyAction => ({
    type: EFavoritesFetch.SUCCESS,
    payload,
});

export const favoritesFetchCountSuccess = (payload: any): AnyAction => ({
    type: EFavoritesFetchCount.SUCCESS,
    payload,
});

const failure = (error: any): AnyAction => ({
    type: EFavoritesFetch.FAILURE,
    error,
});

const getFolderListCall = () => new GetFamilyFolderListCall().makeRequest({ order: ESortOder.desc });
const getFamilyAPICall = () => new GetFamilyAPICall().makeRequest(null, { url: '' });

export const getFavorites =
    ({ limit = FAVORITES_LOAD_LIMIT } = {}): ((
        dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, AnyAction>
    ) => any) =>
    (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, AnyAction>): Promise<any> =>
        new Promise<void>((resolve, reject): void => {
            dispatch(request());

            let familyFeatureCheck;

            getFamilyAPICall()
                .then((response) => {
                    const family = response?.data?.[0]?.services?.cloud?.family;
                    const hasFamilyFeatures = family?.albums && family?.folders;
                    familyFeatureCheck = !familyFoldersSharingInFavorites && hasFamilyFeatures;
                })
                .finally(() => {
                    Promise.all([
                        api.folder.shared.incoming(),
                        callApiLoad({
                            limit,
                        }),
                        /* CLOUDWEB-13693: Бэкенд для favorites не помечаем доменные папки.
                         * поэтому фетчим их отдельно (как это сделано с shared несколькими строчками выше).
                         * TODO: попросить бэк это исправить если возможно.
                         */
                        api.domain.folders(),
                        ...(familyFeatureCheck ? [getFolderListCall()] : []),
                    ])
                        .then(([sharedIncomingResponse = {}, favoritesResponse = {}, domainFolders = [], familyFolders = {}]): void => {
                            const { data: favorites = {} } = favoritesResponse;
                            const { list: sharedIncoming = [] } = sharedIncomingResponse;

                            /**
                             * CLOUD-4624: Форсим тип у семейных папок, починим на бэкенде и уберем костыль
                             */
                            if (familyFeatureCheck) {
                                const familyList = familyFolders?.data?.list;
                                if (familyList?.length) {
                                    favorites.objects = favorites.objects.map((item) =>
                                        familyList.find((familyItem) => familyItem.home === item.home) ? { ...item, kind: 'family' } : item
                                    );
                                }
                            }

                            dispatch(
                                favoritesFetchSuccess({
                                    favorites,
                                    sharedIncoming,
                                    domainFolders,
                                    // B2BCLOUD-6054: id папки «Избранное» нужен для ключа сортировки.
                                    // Берём рантайм-признак isB2BUser, т.к. статический IS_BIZ_USER из SSR
                                    // в web superapp приходит как false до авторизации.
                                    isB2BUser: UserSelectors.isB2BUser(store.getState()),
                                })
                            );
                            resolve();
                        })
                        .catch((error: any): void => reject(dispatch(failure(error))));
                });
        });
